import type { WorkItem } from "@/types";

export const worksList: WorkItem[] = [
  {
    id: "work-01",
    title: "雾港",
    type: "电影",
    year: 2026,
    summary:
      "潮湿浓雾笼罩的港口城市，一名女性在寻找失踪亲人的过程中，逐渐揭开被刻意掩埋的真相。",
    content: [
      "《雾港》是一部以港口城市为背景的悬疑剧情片。故事从一场突如其来的失踪案开始，主人公在潮湿、浓雾弥漫的城市里穿梭，一步步接近被隐藏多年的真相。",
      "影片以大量实景拍摄完成，水下与夜戏几乎全部采用实拍。风间由美在片中承担了高强度的体能与情绪表演，被评价为“克制而富有层次”。",
      "该片入围多个国际影展主竞赛单元，预计于年底在多地区上映。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Foggy%20harbor%20city%20at%20dusk%20with%20warm%20distant%20lights%20and%20mist%20over%20water%2C%20cinematic%20atmospheric%20photography%2C%20deep%20orange%20and%20slate%20palette%2C%20moody%20composition%2C%20high%20detail&width=800&height=600&seq=work-mist-harbor&orientation=landscape",
    cast: [
      { name: "风间由美", role: "饰 沈黎" },
      { name: "陈沐", role: "饰 老周" },
      { name: "许南", role: "饰 阿棠" },
      { name: "顾晨", role: "导演" },
    ],
    tags: ["悬疑", "剧情"],
  },
  {
    id: "work-02",
    title: "长夜将明",
    type: "电视剧",
    year: 2026,
    summary:
      "一桩跨越十年的旧案，一对命运迥异的双胞胎姐妹，真相在长夜里一点点浮出水面。",
    content: [
      "《长夜将明》围绕一桩跨越十年的旧案展开，风间由美一人分饰性格迥异的双胞胎姐妹。",
      "为区分两个角色，她从习惯动作、说话节奏到呼吸方式都做了细致设计，并提前两个月参与方言与形体训练。",
      "剧集计划于明年第二季度开机，具体上线时间待定。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20city%20alley%20at%20night%20with%20warm%20street%20lamps%20and%20long%20shadows%2C%20cinematic%20suspense%20atmosphere%2C%20orange%20and%20charcoal%20palette%2C%20artistic%20photography%2C%20high%20detail&width=800&height=600&seq=work-long-night&orientation=landscape",
    cast: [
      { name: "风间由美", role: "饰 林漾 / 林汐" },
      { name: "宋一航", role: "饰 程野" },
      { name: "林哲", role: "导演" },
    ],
    tags: ["悬疑", "都市"],
  },
  {
    id: "work-03",
    title: "潮汐备忘录",
    type: "音乐",
    year: 2025,
    summary:
      "五首围绕“潮汐”意象的作品，融合民谣与氛围电子，讲述人与人靠近与远离的节奏。",
    content: [
      "《潮汐备忘录》是风间由美与音乐人林澈共同制作的EP，收录五首作品。",
      "概念围绕潮汐的涨落，隐喻人际关系中反复出现的靠近与疏离。编曲保留了大量留白与气声。",
      "实体专辑采用再生纸印刷，封面为手工丝网版画。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20ocean%20waves%20with%20soft%20warm%20sunset%20gradient%20and%20minimal%20horizon%2C%20artistic%20photography%2C%20orange%20and%20sand%20palette%2C%20dreamy%20atmosphere%2C%20high%20detail&width=800&height=600&seq=work-tide-memo&orientation=landscape",
    cast: [
      { name: "风间由美", role: "演唱 / 作词" },
      { name: "林澈", role: "制作 / 编曲" },
    ],
    tags: ["民谣", "氛围电子"],
  },
  {
    id: "work-04",
    title: "未寄出的信",
    type: "音乐",
    year: 2025,
    summary: "以钢琴与弦乐为底色的抒情单曲，词作取材于多年手写日记，私密而真诚。",
    content: [
      "《未寄出的信》是一首抒情单曲，由风间由美亲自参与作词。",
      "编曲刻意保留了呼吸声与翻页的细碎声响，希望听众仿佛坐在同一间房里。",
      "歌曲上线首日即进入多个平台新歌榜前三。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20piano%20with%20sheet%20music%20and%20warm%20window%20light%2C%20abstract%20minimal%20still%20life%2C%20cream%20and%20amber%20palette%2C%20artistic%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=work-unsent-letter&orientation=landscape",
    cast: [
      { name: "风间由美", role: "演唱 / 作词" },
      { name: "苏也", role: "作曲" },
    ],
    tags: ["抒情", "钢琴"],
  },
  {
    id: "work-05",
    title: "山与海之间",
    type: "电影",
    year: 2025,
    summary:
      "一段跨越二十年的亲情故事，在群山与海岸之间，讲述一次迟到太久的和解。",
    content: [
      "《山与海之间》讲述一对父女在二十年隔阂后重新面对彼此的故事。",
      "影片以四季实景拍摄，风间由美为角色增重并学习当地方言，表演被评价“朴素而有力量”。",
      "她凭该片获得年度最佳女演员提名。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Coastal%20mountains%20at%20golden%20hour%20with%20warm%20sunlight%20and%20soft%20mist%2C%20cinematic%20landscape%20photography%2C%20orange%20and%20sage%20palette%2C%20artistic%20composition%2C%20high%20detail&width=800&height=600&seq=work-mountain-sea&orientation=landscape",
    cast: [
      { name: "风间由美", role: "饰 江遥" },
      { name: "周敬川", role: "饰 江父" },
      { name: "叶宁", role: "导演" },
    ],
    tags: ["剧情", "亲情"],
  },
  {
    id: "work-06",
    title: "日常的褶皱",
    type: "电视剧",
    year: 2024,
    summary: "由六个独立单元组成的都市生活剧，讲述平凡日子里的细小转折与温柔。",
    content: [
      "《日常的褶皱》以六个独立单元展现普通人的生活切片，风间由美主演其中三个单元。",
      "全剧采用大量长镜头与自然光，追求生活化的真实质感。",
      "该剧播出后获得良好口碑，被评为年度最具温度的剧集之一。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20small%20apartment%20interior%20with%20warm%20afternoon%20light%20and%20soft%20film%20grain%2C%20abstract%20lifestyle%20still%20life%2C%20cream%20and%20amber%20palette%2C%20high%20detail&width=800&height=600&seq=work-daily-folds&orientation=landscape",
    cast: [
      { name: "风间由美", role: "主演" },
      { name: "郑晓", role: "导演" },
    ],
    tags: ["都市", "生活"],
  },
  {
    id: "work-07",
    title: "回声之地",
    type: "纪录片",
    year: 2026,
    summary: "以三条河流为线索的自然人文纪录片，风间由美担任全片旁白配音。",
    content: [
      "《回声之地》以三条河流为线索，记录沿岸普通人的生活与迁徙。",
      "风间由美受邀担任旁白配音，她形容这次工作最难的是“学会安静”。",
      "影片以大量长镜头呈现自然与人的关系，画面克制而辽阔。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20river%20bend%20with%20soft%20morning%20mist%20and%20warm%20sun%2C%20documentary%20landscape%20photography%2C%20orange%20and%20sage%20palette%2C%20artistic%20composition%2C%20high%20detail&width=800&height=600&seq=work-echo-land&orientation=landscape",
    cast: [
      { name: "风间由美", role: "旁白" },
      { name: "苏砚", role: "导演" },
    ],
    tags: ["自然", "人文"],
  },
  {
    id: "work-08",
    title: "夏日白噪音",
    type: "电影",
    year: 2024,
    summary: "一部关于青春与告别的夏日电影，蝉鸣、海风与一段没有结局的暗恋。",
    content: [
      "《夏日白噪音》讲述一段发生在海边小镇的青春故事，关于暗恋、告别与成长。",
      "影片以手持摄影与自然音效营造出强烈的夏日氛围。",
      "风间由美在片中饰演一位返乡的年轻教师，表演清新自然。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Sunny%20seaside%20town%20with%20warm%20summer%20light%20and%20gentle%20waves%2C%20nostalgic%20cinematic%20photography%2C%20orange%20and%20cream%20palette%2C%20soft%20grain%2C%20high%20detail&width=800&height=600&seq=work-summer-noise&orientation=landscape",
    cast: [
      { name: "风间由美", role: "饰 许夏" },
      { name: "宋一航", role: "饰 陈屿" },
      { name: "林哲", role: "导演" },
    ],
    tags: ["青春", "成长"],
  },
  {
    id: "work-09",
    title: "回声的另一半",
    type: "音乐",
    year: 2023,
    summary: "首张个人专辑，收录九首作品，横跨民谣、流行与轻电子的声音实验。",
    content: [
      "《回声的另一半》是风间由美的首张个人专辑，收录九首作品。",
      "专辑横跨民谣、流行与轻电子，记录了她从演员到歌手身份转换过程中的自我对话。",
      "专辑同名巡演在多个城市举行，均以小型剧场形式呈现。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20sound%20wave%20visual%20with%20warm%20amber%20gradient%20and%20grain%2C%20minimal%20album%20art%20aesthetic%2C%20orange%20and%20sand%20palette%2C%20artistic%20photography%2C%20high%20detail&width=800&height=600&seq=work-echo-half&orientation=landscape",
    cast: [{ name: "风间由美", role: "演唱 / 词曲" }],
    tags: ["流行", "民谣"],
  },
];

export const workTypes = ["电影", "电视剧", "音乐", "纪录片"];
export const workYears = [2026, 2025, 2024, 2023];